<template>
  <nav>
    <div
      class="hidden md:flex flex-row py-3 px-10"
      :class="[$route.name !== 'home_landing' ? 'bg-white' : 'bg-transparent']"
    >
      <!-- START LOGO -->
      <router-link
        tag="div"
        :to="{ name: 'home_landing' }"
        class="flex flex-row"
      >
        <div class="flex items-center">
          <img class="w-8 h-7" src="@/assets/images/main-logo.svg" />
        </div>
        <div class="flex items-center ml-5">
          <p class="text-lg">Rent Application</p>
        </div>
      </router-link>
      <!-- END LOGO -->

      <div class="flex flex-row flex-1 justify-end">
        <router-link
          tag="div"
          :to="{ name: 'home_brokerage' }"
          class="flex items-center px-8"
          @click="closeMenu"
        >
          <p class="text-base">Brokerage</p>
        </router-link>

        <MenuDropdown />

        <!-- <router-link
          tag="div"
          :to="{ name: 'home_demo' }"
          class="flex items-center px-8"
        >
          <p class="text-lg">View Demo</p>
        </router-link> -->

        <div class="flex items-center mx-2 w-24">
          <SecondaryButton @click="goToLogin">Login</SecondaryButton>
        </div>

        <div class="flex items-center mx-2 w-24">
          <PrimaryButton @click="goToSignup">Signup</PrimaryButton>
        </div>
      </div>
    </div>

    <!-- START MOBILE TOP MENU -->
    <div class="md:hidden bg-white flex flex-col">
      <div class="flex justify-between">
        <div class="">
          <button
            class="
              mobile-menu-button
              py-4
              px-2
              focus:outline-none focus:bg-gray-700
            "
            @click="toggleMenu"
          >
            <MenuIcon class="w-7 h-7 text-brand-green" />
          </button>
        </div>

        <div class="flex items-center justify-center">
          <img class="w-8 h-8 mr-2" src="@/assets/images/main-logo.svg" />
          <p class="text-lg text-brand-black font-semibold capitalize">
            Rent Application
          </p>
        </div>

        <div class="px-5 py-3 flex items-center justify-end"></div>
      </div>
    </div>
    <!-- END MOBILE TOP MENU -->
  </nav>

  <!-- START MOBILE SIDE MENU -->
  <div
    class="
      sidebar
      bg-white
      shadow-md
      w-20
      py-2
      inset-y-0
      left-0
      transform
      md:relative md:translate-x-0
      transition
      duration-200
      ease-in-out
      z-20
      h-screen
      w-52
      md:hidden
      fixed
    "
    :class="[showMenu ? 'translate-x-0' : '-translate-x-full']"
    ref="menu"
    v-if="showMenu"
  >
    <!-- logo -->
    <div class="flex flex-col justify-between items-stretch h-full">
      <div class="flex flex-col">
        <div class="flex justify-end">
          <div
            v-if="showMenu"
            @click="toggleMenu"
            class="flex items-center px-3"
          >
            <XIcon class="text-brand-green w-8 h-8" />
          </div>
        </div>

        <!-- nav -->
        <nav class="py-5 px-5">
          <router-link
            tag="div"
            :to="{ name: 'home_landing' }"
            class="flex flex-col mb-5"
          >
            <div class="flex">
              <img class="w-8 h-8" src="@/assets/images/main-logo.svg" />
            </div>
            <div class="flex items-center py-1">
              <p class="text-lg">Rent Application</p>
            </div>
          </router-link>

          <router-link
            tag="div"
            :to="{ name: 'home_brokerage' }"
            class="py-2"
            @click="closeMenu"
          >
            Brokerage
          </router-link>

          <div class="w-full py-2">
            <Line />
          </div>

          <SecondaryButton @click="goToLogin">Login</SecondaryButton>

          <div class="w-full py-2">
            <Line />
          </div>

          <PrimaryButton @click="goToSignup">Signup</PrimaryButton>

          <div class="w-full py-2">
            <Line />
          </div>

          <div class="flex flex-col">
            <p class="text-brand-blue uppercase py-2">Samples</p>

            <router-link
              tag="div"
              class="py-2"
              :to="{ name: 'apply_sample' }"
              @click="closeMenu"
            >
              Interactive Application
            </router-link>

            <router-link
              tag="div"
              class="py-2"
              :to="{ name: 'home_demo' }"
              @click="closeMenu"
            >
              Processed Reports
            </router-link>
          </div>
        </nav>
      </div>
    </div>
  </div>
  <!-- END DESKTOP SIDE MENU -->
</template>
<script>
import { XIcon, MenuIcon } from "@heroicons/vue/outline"

export default {
  components: {
    XIcon,
    MenuIcon
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    closeMenu() {
      this.showMenu = false
    },
    goToLogin() {
      this.closeMenu()
      this.$router.push({ name: "home_login" })
    },
    goToSignup() {
      this.closeMenu()
      this.$router.push({ name: "home_signup" })
    }
  }
}
</script>
